import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaidarshanca() {



  const cardData = {




keyword: "Pune to Mumbai Darshan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Mumbai Darshan Cab Service for families, couples, senior citizens, business travelers, and groups planning a convenient Mumbai sightseeing trip from Pune. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-day Mumbai Darshan, customized sightseeing, one-way travel, and round trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes Mumbai sightseeing convenient and comfortable. Travelers can customize their itinerary according to their preferred attractions, travel timings, and sightseeing requirements.",

topPlaces: [
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a large protected green area within Mumbai and offers visitors a different experience from the city's busy commercial districts. Families and nature lovers can explore its greenery, trails, and natural surroundings. Travelers booking a Pune to Mumbai Darshan Cab can include the park in their customized sightseeing itinerary and travel comfortably between attractions."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a popular seafront promenade known for Arabian Sea views, evening walks, nearby landmarks, and its lively atmosphere. It is a convenient sightseeing stop for couples, families, and first-time visitors to Mumbai. Garud Cab Service provides private transportation from Pune, allowing travelers to include Bandstand along with other western Mumbai attractions."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple in Prabhadevi is one of Mumbai's most visited temples and is dedicated to Lord Ganesha. Devotees from Pune frequently include the temple in their Mumbai travel plans. A private darshan cab provides convenient transportation for families and senior citizens, with flexible arrangements to visit the temple and continue toward other Mumbai sightseeing destinations."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus is a historic railway station and a UNESCO World Heritage Site known for its impressive Victorian Gothic architecture. It is an important landmark for visitors interested in Mumbai's history and heritage. Customers can include the station in their Mumbai Darshan itinerary and comfortably travel to nearby attractions by private cab."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most recognizable waterfront attractions, offering scenic views of the Arabian Sea and the famous city skyline. It is especially popular for evening sightseeing and relaxed walks. Travelers from Pune can book a private cab for a Mumbai Darshan trip and include Marine Drive as part of a flexible sightseeing route covering multiple city landmarks."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are a major heritage attraction located on Elephanta Island and are known for ancient rock-cut temples and sculptures dedicated primarily to Shiva. Visitors can include the caves in a Mumbai sightseeing plan with appropriate ferry arrangements. Garud Cab Service can provide convenient road transportation from Pune to the ferry departure area as part of a customized itinerary."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is a prominent religious landmark located on an islet off the Mumbai coastline and is visited by people from different backgrounds. Its distinctive location and waterfront setting make it an important Mumbai sightseeing stop. Customers traveling from Pune can conveniently include Haji Ali in their darshan itinerary with private chauffeur-driven transportation."
  },
  {
    title: "Nehru Planetarium",
    description: "Nehru Planetarium is a popular educational and recreational attraction in Mumbai offering visitors an opportunity to learn about astronomy and space science. It is particularly suitable for families and children. Travelers booking a Pune to Mumbai Darshan Cab can include the planetarium in their sightseeing schedule and travel comfortably between South Mumbai attractions."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic waterfront location offering views of the Arabian Sea and Mumbai's modern skyline, including the Bandra-Worli Sea Link. It is a popular stop for photography, evening drives, and relaxed sightseeing. Garud Cab Service provides private cab transportation from Pune, allowing customers to include Worli in a customized Mumbai Darshan route."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda near Gorai is a distinctive meditation and spiritual center known for its large golden dome and peaceful surroundings. It offers a quieter sightseeing experience away from central Mumbai's busy areas. Customers can include the pagoda in a full-day Mumbai Darshan itinerary and use a private cab for convenient transportation from Pune."
  }
],



"services": [
{
"name": "Pune to Mumbai Darshan Cabs",
"description": "Book Pune to Mumbai Darshan Cabs for comfortable and convenient religious and sightseeing travel with professional chauffeurs and well-maintained air-conditioned vehicles. The service is suitable for families, senior citizens, couples, devotees, and groups visiting temples, popular attractions, and important places across Mumbai."
},
{
"name": "Mumbai Darshan Cab from Pune",
"description": "Choose a Mumbai Darshan Cab from Pune for a private and comfortable journey to Mumbai's temples, tourist attractions, and religious destinations. Enjoy convenient pickup, experienced drivers, AC interiors, flexible travel arrangements, and suitable vehicle options for family and group darshan trips."
},
{
"name": "Pune to Mumbai Cab",
"description": "Book a Pune to Mumbai Cab for reliable intercity transportation with convenient pickup and direct destination drop. Comfortable AC cars with professional chauffeurs are suitable for business travel, family journeys, sightseeing, airport transfers, temple visits, and planned Mumbai trips."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Reserve a Pune to Mumbai Airport Cab for convenient transportation to Mumbai Airport with scheduled pickup and direct airport drop. The service offers comfortable AC vehicles, professional chauffeurs, practical luggage space, and flexible travel arrangements for domestic and international passengers."
},
{
"name": "Pune Mumbai Cab",
"description": "Choose Pune Mumbai Cab service for comfortable point-to-point transportation between Pune and Mumbai. The service is suitable for individuals, families, corporate travelers, tourists, airport passengers, and customers looking for private AC travel with convenient pickup and destination drop."
},
{
"name": "Pune to Mumbai Taxi",
"description": "Book a Pune to Mumbai Taxi for a comfortable and dependable intercity journey with an experienced chauffeur. Customers can choose suitable vehicles for family travel, office visits, sightseeing, airport transfers, temple darshan, and other personal trips between Pune and Mumbai."
},
{
"name": "Pune to Mumbai Airport Cab Fare",
"description": "Choose a Pune to Mumbai Airport Cab according to your preferred vehicle and travel requirements. Sedan, SUV, and premium options can provide comfortable airport transportation with professional drivers, scheduled pickup, luggage space, and direct drop at Mumbai Airport."
},
{
"name": "Pune Mumbai Airport Drop",
"description": "Book Pune Mumbai Airport Drop service for convenient door-to-airport transportation with a professional chauffeur. The service is suitable for passengers traveling from Pune to Mumbai Airport for domestic or international flights, offering comfortable AC vehicles and planned pickup arrangements."
},
{
"name": "Pune to Mumbai Cheapest Cab",
"description": "Choose a Pune to Mumbai Cheapest Cab option for economical private travel without compromising on basic comfort and convenience. The service is suitable for budget-conscious passengers, families, students, business travelers, and individuals planning one-way or return journeys."
},
{
"name": "Pune to Mumbai Cab Service",
"description": "Book Pune to Mumbai Cab Service for dependable private transportation between the two cities. Enjoy convenient pickup, comfortable AC seating, professional chauffeur service, and vehicle choices suitable for airport transfers, business travel, family trips, sightseeing, and religious visits."
},
{
"name": "Best Cab Service Pune to Mumbai",
"description": "Choose Best Cab Service Pune to Mumbai for comfortable and professionally managed intercity travel. The service provides clean vehicles, experienced chauffeurs, convenient pickup, practical luggage space, and flexible journey options for families, corporate travelers, tourists, and individual passengers."
},
{
"name": "Pune to Mumbai Cab Fare",
"description": "Book a Pune to Mumbai Cab based on your preferred vehicle type and travel plan. Sedan, SUV, and larger vehicle options are suitable for different passenger requirements, with comfortable AC travel, professional chauffeur service, convenient pickup, and direct destination drop."
},
{
"name": "Pune to Mumbai Cab Charges",
"description": "Choose Pune to Mumbai Cab transportation with flexible vehicle options for different journey requirements. Whether traveling alone, with family, for business, or for sightseeing, passengers can select a suitable AC vehicle with convenient pickup and professional chauffeur-driven service."
},
{
"name": "Pune Mumbai Taxi Service",
"description": "Book Pune Mumbai Taxi Service for convenient and comfortable transportation between Pune and Mumbai. The service is suitable for airport transfers, office travel, family journeys, sightseeing, temple visits, and personal trips with professional chauffeurs and well-maintained vehicles."
},
{
"name": "Pune to Mumbai Car",
"description": "Hire a Pune to Mumbai Car with a professional chauffeur for comfortable point-to-point transportation. Select a suitable sedan, SUV, or premium vehicle for business visits, family travel, airport transfers, sightseeing, religious trips, and other planned journeys between Pune and Mumbai."
},
{
"name": "Pune Mumbai Taxi Fare",
"description": "Choose Pune Mumbai Taxi transportation according to your passenger and vehicle requirements. Comfortable AC cars with professional drivers are suitable for one-way travel, return trips, airport transfers, family journeys, corporate visits, sightseeing, and temple darshan programs."
},
{
"name": "Pune to Mumbai International Airport Cab",
"description": "Book Pune to Mumbai International Airport Cab for convenient transportation to Mumbai's international airport terminal. The service provides scheduled pickup, direct airport drop, comfortable AC interiors, luggage space, and professional chauffeur assistance for passengers traveling from Pune."
},
{
"name": "Pune to Mumbai Cab Price",
"description": "Select a Pune to Mumbai Cab according to your preferred vehicle and journey requirements. Sedan, SUV, Innova, and other options can provide comfortable private transportation for airport travel, business visits, family trips, sightseeing, religious journeys, and one-way transfers."
},
{
"name": "Pune to Mumbai Airport Cab Price",
"description": "Book Pune to Mumbai Airport Cab for a convenient and comfortable airport transfer with scheduled pickup and direct destination drop. The service is suitable for individual passengers, families, corporate travelers, and international travelers carrying luggage for their Mumbai flight."
},
{
"name": "Pune to Mumbai Innova Cab",
"description": "Choose Pune to Mumbai Innova Cab for spacious and comfortable family or group travel. The Innova provides practical seating and luggage capacity with professional chauffeur service, making it suitable for airport transfers, sightseeing, business travel, temple visits, and longer journeys."
},
{
"name": "Pune to Mumbai Taxi One Way",
"description": "Book Pune to Mumbai Taxi One Way for convenient point-to-point travel without requiring a return journey. Enjoy private AC transportation, professional chauffeur service, scheduled pickup, and direct destination drop for business trips, family travel, airport transfers, and sightseeing."
},
{
"name": "Pune to Mumbai Cab Booking",
"description": "Make Pune to Mumbai Cab Booking for scheduled intercity transportation with convenient pickup and destination drop. Select a comfortable vehicle for airport travel, business meetings, family journeys, sightseeing, temple visits, and other planned trips between Pune and Mumbai."
},
{
"name": "Pune to Mumbai Cab Cost",
"description": "Choose a Pune to Mumbai Cab based on your preferred vehicle category, passenger count, and travel plan. Comfortable chauffeur-driven cars are available for one-way journeys, round trips, airport transfers, corporate travel, sightseeing, and religious visits between Pune and Mumbai."
},
{
"name": "Pune to Mumbai Airport Taxi",
"description": "Book Pune to Mumbai Airport Taxi for comfortable and scheduled transportation to Mumbai Airport. Professional chauffeurs, AC interiors, luggage space, and convenient pickup arrangements make the service suitable for passengers traveling for domestic and international flights."
},
{
"name": "Pune to Mumbai Airport Drop Innova",
"description": "Choose Pune to Mumbai Airport Drop Innova for spacious and comfortable airport transportation for families and groups. The vehicle provides practical seating and luggage space with professional chauffeur service and convenient pickup from homes, offices, hotels, and other Pune locations."
},
{
"name": "Pune Mumbai Cab One Way",
"description": "Book Pune Mumbai Cab One Way for a private intercity transfer from Pune to Mumbai without the need for a return booking. The service is suitable for airport travel, business visits, family transportation, sightseeing, temple darshan, and other planned journeys."
},
{
"name": "Pune to Mumbai SUV Cab",
"description": "Choose Pune to Mumbai SUV Cab for passengers who prefer additional cabin space and comfortable long-distance travel. SUV transportation is suitable for families, groups, business travelers, airport passengers, sightseeing tours, and religious journeys requiring a spacious private vehicle."
},
{
"name": "Pune to Mumbai Darshan Cab",
"description": "Book Pune to Mumbai Darshan Cab for a convenient religious journey covering important temples and spiritual destinations in Mumbai. Enjoy private AC transportation, professional chauffeur service, flexible travel arrangements, and suitable vehicle choices for families, devotees, and senior citizens."
},
{
"name": "Pune to Mumbai Temple Darshan Cab",
"description": "Choose Pune to Mumbai Temple Darshan Cab for comfortable private travel to popular Mumbai temples. The service is suitable for families, devotees, senior citizens, and groups visiting religious destinations with convenient pickup, experienced chauffeurs, AC vehicles, and flexible sightseeing arrangements."
},
{
"name": "Pune to Mumbai Siddhivinayak Darshan Cab",
"description": "Book Pune to Mumbai Siddhivinayak Darshan Cab for a comfortable journey from Pune to Siddhivinayak Temple and other Mumbai destinations. Enjoy private AC transportation, professional chauffeur service, convenient pickup, and flexible travel planning for families and devotees."
},
{
"name": "Pune to Mumbai Mahalaxmi Temple Cab",
"description": "Choose Pune to Mumbai Mahalaxmi Temple Cab for convenient religious travel from Pune to Mahalaxmi Temple and nearby Mumbai attractions. The service provides comfortable private transportation, professional chauffeurs, AC interiors, and flexible journey options for families and devotees."
},
{
"name": "Pune to Mumbai Mumbadevi Darshan Taxi",
"description": "Book Pune to Mumbai Mumbadevi Darshan Taxi for comfortable transportation to Mumbadevi Temple and other religious locations in Mumbai. The service is suitable for families, senior citizens, devotees, and tourists looking for private chauffeur-driven travel from Pune."
},
{
"name": "Pune to Mumbai Haji Ali Darshan Cab",
"description": "Choose Pune to Mumbai Haji Ali Darshan Cab for a convenient religious and sightseeing journey from Pune to Haji Ali and nearby attractions. Comfortable AC vehicles, professional chauffeurs, practical luggage space, and flexible travel arrangements make the service suitable for families and groups."
},
{
"name": "Pune to Mumbai Religious Tour Cab",
"description": "Book Pune to Mumbai Religious Tour Cab for private transportation to important temples and spiritual destinations across Mumbai. The service is suitable for devotees, families, senior citizens, and groups requiring comfortable AC travel with professional chauffeurs and flexible sightseeing schedules."
},
{
"name": "Pune to Mumbai Darshan Innova Cab",
"description": "Choose Pune to Mumbai Darshan Innova Cab for spacious and comfortable religious travel with family or a small group. The Innova provides practical seating and luggage capacity with a professional chauffeur, making it suitable for temple visits and full-day Mumbai darshan."
},
{
"name": "Pune to Mumbai Darshan Innova Crysta Cab",
"description": "Book Pune to Mumbai Darshan Innova Crysta Cab for premium and spacious transportation during a Mumbai religious tour. The vehicle offers comfortable seating, AC interiors, practical luggage space, and professional chauffeur service for families, senior citizens, devotees, and groups."
},
{
"name": "Pune to Mumbai Darshan Ertiga Cab",
"description": "Choose Pune to Mumbai Darshan Ertiga Cab for comfortable family and group transportation during temple visits and sightseeing. The Ertiga provides practical seating and luggage space with professional chauffeur service for a convenient private journey from Pune to Mumbai."
},
{
"name": "Pune to Mumbai Darshan Sedan Cab",
"description": "Book Pune to Mumbai Darshan Sedan Cab for economical and comfortable private transportation for couples, individuals, and small families. Enjoy AC interiors, comfortable seating, professional chauffeur service, convenient pickup, and flexible travel arrangements for Mumbai temple visits."
},
{
"name": "Pune to Mumbai Darshan SUV Taxi",
"description": "Choose Pune to Mumbai Darshan SUV Taxi for spacious private travel during religious and sightseeing trips. The SUV is suitable for families and groups visiting temples, tourist attractions, and other Mumbai destinations while enjoying comfortable AC travel and professional chauffeur service."
},
{
"name": "Pune to Mumbai Darshan AC Cab",
"description": "Book Pune to Mumbai Darshan AC Cab for comfortable private transportation throughout your Mumbai religious and sightseeing journey. Enjoy air-conditioned interiors, convenient pickup, professional chauffeur service, and suitable vehicle options for families, devotees, tourists, and senior passengers."
}
],
"tableData": [
["Pune to Mumbai Darshan Cabs", "Mumbai Darshan Cab from Pune"],
["Pune to Mumbai Cab", "Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab", "Pune to Mumbai Taxi"],
["Pune to Mumbai Airport Cab Fare", "Pune Mumbai Airport Drop"],
["Pune to Mumbai Cheapest Cab", "Pune to Mumbai Cab Service"],
["Best Cab Service Pune to Mumbai", "Pune to Mumbai Cab Fare"],
["Pune to Mumbai Cab Charges", "Pune Mumbai Taxi Service"],
["Pune to Mumbai Car", "Pune Mumbai Taxi Fare"],
["Pune to Mumbai International Airport Cab", "Pune to Mumbai Cab Price"],
["Pune to Mumbai Airport Cab Price", "Pune to Mumbai Innova Cab"],
["Pune to Mumbai Taxi One Way", "Pune to Mumbai Cab Booking"],
["Pune to Mumbai Cab Cost", "Pune to Mumbai Airport Taxi"],
["Pune to Mumbai Airport Drop Innova", "Pune Mumbai Cab One Way"],
["Pune to Mumbai SUV Cab", "Pune to Mumbai Darshan Cab"],
["Pune to Mumbai Temple Darshan Cab", "Pune to Mumbai Siddhivinayak Darshan Cab"],
["Pune to Mumbai Mahalaxmi Temple Cab", "Pune to Mumbai Mumbadevi Darshan Taxi"],
["Pune to Mumbai Haji Ali Darshan Cab", "Pune to Mumbai Religious Tour Cab"],
["Pune to Mumbai Darshan Innova Cab", "Pune to Mumbai Darshan Innova Crysta Cab"],
["Pune to Mumbai Darshan Ertiga Cab", "Pune to Mumbai Darshan Sedan Cab"],
["Pune to Mumbai Darshan SUV Taxi", "Pune to Mumbai Darshan AC Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Mumbai Darshan Cab for a Planned City Tour",
    WhyChoosedescription: "Garud Cab Service offers private Pune to Mumbai Darshan cab services for families, couples, senior citizens, and groups who want to explore Mumbai's important landmarks in a comfortable and flexible vehicle."
  },
  {
    WhyChooseheading: "Private Cab for Mumbai Sightseeing",
    WhyChoosedescription: "Enjoy a dedicated vehicle throughout your Pune to Mumbai sightseeing trip, allowing your group to travel together and spend time at selected attractions without depending on multiple local transport options."
  },
  {
    WhyChooseheading: "Explore Mumbai's Famous Landmarks",
    WhyChoosedescription: "Plan your sightseeing around popular Mumbai attractions such as Gateway of India, Marine Drive, Chhatrapati Shivaji Maharaj Terminus, Siddhivinayak Temple, Juhu Beach, and other places according to your itinerary."
  },
  {
    WhyChooseheading: "Convenient for Families & Senior Citizens",
    WhyChoosedescription: "A private sightseeing cab allows families and senior passengers to plan suitable travel timings, rest breaks, pickup points, and sightseeing stops according to their comfort."
  },
  {
    WhyChooseheading: "Same-Day Mumbai Darshan Option",
    WhyChoosedescription: "For travellers with limited time, a same-day Pune to Mumbai darshan trip can be planned around the attractions you want to visit and your preferred departure and return schedule."
  },
  {
    WhyChooseheading: "Customized Sightseeing Itinerary",
    WhyChoosedescription: "Create an itinerary based on your interests, available time, and preferred Mumbai locations instead of following a fixed sightseeing route, making the trip more suitable for your group."
  },
  {
    WhyChooseheading: "Flexible One-Way & Return Arrangements",
    WhyChoosedescription: "Choose one-way transportation if you plan to stay in Mumbai or arrange a return cab when you want to complete your Mumbai darshan and travel back to Pune on the same day or another scheduled date."
  },
  {
    WhyChooseheading: "Organize Your Mumbai Darshan with Garud",
    WhyChoosedescription: "Share your Pune pickup location, sightseeing preferences, travel date, passenger count, preferred vehicle, and return requirements with Garud Cab Service to plan your Mumbai darshan journey."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Mumbai Darshan Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Mumbai darshan cabs for families, couples, senior citizens, tourists, and groups planning a Mumbai sightseeing trip."
  },
  {
    question: "Can I book a same-day Pune to Mumbai Darshan cab?",
    answer: "Yes, a same-day sightseeing trip can be arranged according to your preferred attractions, departure timing, sightseeing schedule, and return plan."
  },
  {
    question: "Which places can I visit during Mumbai Darshan?",
    answer: "You can plan visits to attractions such as Gateway of India, Marine Drive, CSMT, Siddhivinayak Temple, Juhu Beach, and other suitable Mumbai landmarks."
  },
  {
    question: "Can I customize my Mumbai sightseeing itinerary?",
    answer: "Yes, the itinerary can be planned according to your preferred attractions, available time, passenger requirements, and sightseeing priorities."
  },
  {
    question: "Is the Mumbai Darshan cab suitable for families?",
    answer: "Yes, private sightseeing cabs are suitable for families and groups who want to travel together and manage their sightseeing schedule comfortably."
  },
  {
    question: "Can senior citizens travel comfortably for Mumbai Darshan?",
    answer: "Yes, a private cab can be a convenient option for senior citizens because the trip can be planned with suitable travel timings, breaks, and preferred sightseeing stops."
  },
  {
    question: "Can I book a return cab from Mumbai to Pune?",
    answer: "Yes, you can arrange a return journey from Mumbai to Pune after completing your sightseeing, either on the same day or according to your planned schedule."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another convenient location in Pune."
  },
  {
    question: "Which vehicles can be used for Mumbai Darshan?",
    answer: "Vehicle options can be selected according to passenger count, luggage requirements, comfort preferences, and availability at the time of booking."
  },
  {
    question: "How can I book a Pune to Mumbai Darshan Cab?",
    answer: "Share your Pune pickup location, travel date, passenger details, sightseeing preferences, preferred vehicle, and one-way or return requirement with Garud Cab Service to arrange your Mumbai darshan cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Joshi",
    feedback: "We planned a Mumbai Darshan trip from Pune with our family and covered several famous places in one day. Having a private cab made the sightseeing schedule much easier to manage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Patil",
    feedback: "Our parents joined us for Mumbai sightseeing, so we preferred a private cab. The flexible stops and comfortable travel made the day more convenient for everyone.",
    rating: 5
  }
];




















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Darshan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-mumbai-darshan-cab-service.webp",
  "description": "Book Pune to Mumbai Darshan Cab with Garud Cab for comfortable and convenient Mumbai sightseeing travel from Pune. Get reliable cab services for Mumbai Darshan tours, Pune to Mumbai trips, Mumbai Airport transfers, and city sightseeing with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for families, couples, and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-mumbai-darshan-cab-service"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Darshan Cab | Mumbai Sightseeing Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Darshan Cab with Garud Cab for comfortable Mumbai sightseeing and city travel. Get reliable Pune to Mumbai, Mumbai Darshan, and Mumbai Airport cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Darshan Cabs, Mumbai Darshan Cab from Pune, Pune to Mumbai Cab, Pune to Mumbai Airport Cab, Pune Mumbai Cab, Mumbai Darshan Taxi Service, Pune to Mumbai Sightseeing Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaidarshanca;